module.exports = __webpack_public_path__ + "static/media/Mock-pasos.bde7cdba.png";